import React from 'react';
import classNames from 'classnames';
import { Search } from 'lucide-react';

export interface DarkMinimalFilterProps {
  value: string;
  onChange: (next: string) => void;
  onEnter?: () => void;
  placeholder?: string;
  size?: 'sm' | 'md';
  className?: string;
}

export default function DarkMinimalFilter({
  value,
  onChange,
  onEnter,
  placeholder = 'Filter…',
  size = 'sm',
  className,
}: DarkMinimalFilterProps) {
  const isSm = size === 'sm';

  return (
    <div
      className={classNames(
        'pac-glass-input flex items-center w-full rounded-md',
        isSm ? 'h-8' : 'h-10',
        className
      )}
    >
      <div className={classNames('flex-shrink-0', isSm ? 'pl-2' : 'pl-3')}>
        <Search className={classNames(isSm ? 'h-4 w-4' : 'h-5 w-5', 'text-neutral-600')} />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            onEnter?.();
          }
        }}
        placeholder={placeholder}
        className={classNames(
          'flex-1 bg-transparent outline-none',
          'text-neutral-400 placeholder:text-neutral-600',
          isSm ? 'text-xs px-2' : 'text-sm px-2'
        )}
      />
    </div>
  );
}
